import { Box, BoxProps, ColorOptions, convertHexToRGBA, Image, ModBox, Spacer, Text } from '@jfs/ui-new'
import { Colors } from '../../util/util'

export const InvoiceDetails = ({ data }: any) => {
  const gst = !isNaN(data?.gst) ? parseFloat(data?.gst).toFixed(2) : data?.gst
  const monthlyCharges = !isNaN(data?.monthlyCharges)
    ? parseFloat(data?.monthlyCharges).toFixed(2)
    : data?.monthlyCharges
  return (
    <Box>
      <Box>
        <Image source={'polygon'} width={'100%'} height={7} resizeMode="repeat" />
        <Box bg={convertHexToRGBA(Colors.PRIMARY, 6) as ColorOptions} ph={25}>
          <ModBox flexDirection={'row'} marginVertical={10} justifyContent={'space-between'}>
            <Box flex={1}>
              <Text fontFamily="JioType-Medium" fontSize={14} color={convertHexToRGBA('#000', 65) as ColorOptions}>
                Monthly Charges
              </Text>
            </Box>
            <Box alignSelf={'flex-end'}>
              <Text fontFamily="JioType-Bold" fontSize={14} color={Colors.BLACK_14 as ColorOptions}>
                ₹{monthlyCharges}
              </Text>
            </Box>
          </ModBox>

          <ModBox flexDirection={'row'} marginVertical={10} justifyContent={'space-between'}>
            <Box flex={1}>
              <Text fontFamily="JioType-Medium" fontSize={14} color={convertHexToRGBA('#000', 65) as ColorOptions}>
                18% GST
              </Text>
            </Box>
            <Box alignSelf={'flex-end'}>
              <Text fontFamily="JioType-Bold" fontSize={14} color={Colors.BLACK_14 as ColorOptions}>
                ₹{gst}
              </Text>
            </Box>
          </ModBox>

          <Box height={1} bg="SEPERATOR" width={'100%'} />

          <ModBox show={data?.paidAmount} flexDirection={'row'} marginVertical={15} justifyContent={'space-between'}>
            <Box flex={1}>
              <Text fontFamily="JioType-Medium" fontSize={14} color={convertHexToRGBA('#000', 65) as ColorOptions}>
                Total Charge
              </Text>
            </Box>
            <Box alignSelf={'flex-end'}>
              <Text fontFamily="JioType-Bold" fontSize={18} color={Colors.BLACK_14 as ColorOptions}>
                ₹{data?.paidAmount}
              </Text>
            </Box>
          </ModBox>
        </Box>
        <Box {...style.tranformImage}>
          <Image source={'polygon'} width={'100%'} height={7} resizeMode="repeat" />
        </Box>
      </Box>

      <Spacer size={20} direction="vertical" />
      <Box ph={25}>
        <ModBox show={data?.paidOn} flexDirection={'row'} marginVertical={10} justifyContent={'space-between'}>
          <Box flex={1}>
            <Text fontFamily="JioType-Medium" fontSize={14} color={convertHexToRGBA('#000', 65) as ColorOptions}>
              Paid On
            </Text>
          </Box>
          <Box alignSelf={'flex-end'}>
            <Text fontFamily="JioType-Medium" fontSize={14} color={'BLACK_21' as ColorOptions}>
              {data?.paidOn}
            </Text>
          </Box>
        </ModBox>

        <ModBox
          show={data?.paymentMethod || data?.vpa}
          flexDirection={'row'}
          marginVertical={10}
          justifyContent={'space-between'}>
          <Box flex={1}>
            <Text fontFamily="JioType-Medium" fontSize={14} color={convertHexToRGBA('#000', 65) as ColorOptions}>
              Payment method
            </Text>
          </Box>
          <Box alignSelf={'flex-end'}>
            <Text fontFamily="JioType-Medium" fontSize={14} color={'BLACK_21' as ColorOptions}>
              {data?.paymentMethod} | {data?.vpa}
            </Text>
          </Box>
        </ModBox>
      </Box>
    </Box>
  )
}

const style = {
  tranformImage: {
    transform: [{ rotate: '180deg' }],
  } as BoxProps,
}
